/**
 * /admin — redirects to the canonical dashboard.
 * @file src/web/features/admin/pages/index.tsx
 *
 * The practice dashboard lives at `/dashboard` (features/main/pages/
 * dashboard.tsx), rendered inside this same admin sidebar layout. `/admin`
 * is kept as an alias so old links / the layout's base path still resolve.
 */

import { Navigate } from 'react-router-dom';

export default function AdminIndex() {
  return <Navigate to="/dashboard" replace />;
}
